// Search overlay — shared across all pages
// Each page sets window.SEARCH_PRODUCTS before loading this script

function openSearch() {
  const overlay = document.getElementById('searchOverlay');
  if (!overlay) return;
  overlay.classList.add('is-open');
  lockScroll('search');
  setTimeout(() => document.getElementById('searchInput')?.focus(), 200);
  renderSearch('');
}

function closeSearch() {
  const overlay = document.getElementById('searchOverlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  unlockScroll('search');
  const input = document.getElementById('searchInput');
  if (input) input.value = '';
}

// Sanitize
function _esc(str) {
  const d = document.createElement('div');
  d.textContent = str || '';
  return d.innerHTML;
}

function renderSearch(query) {
  const container = document.getElementById('searchResults');
  if (!container) return;
  const products = window.SEARCH_PRODUCTS || [];
  const q = query.toLowerCase().trim();
  const filtered = q ? products.filter(p =>
    p.name.toLowerCase().includes(q) || p.brand.toLowerCase().includes(q)
  ) : products;

  // Build DOM with fragment instead of innerHTML in loop
  const frag = document.createDocumentFragment();

  const label = document.createElement('div');
  label.className = 'search-label';
  label.textContent = q ? filtered.length + ' resultado' + (filtered.length !== 1 ? 's' : '') : 'Produtos populares';
  frag.appendChild(label);

  filtered.forEach(p => {
    const a = document.createElement('a');
    a.className = 'search-item';
    a.href = p.url;
    a.innerHTML = `
      <div class="search-item__img"><img src="${_esc(p.img)}" alt="${_esc(p.name)}" /></div>
      <div class="search-item__info"><div class="search-item__name">${_esc(p.name)}</div><div class="search-item__brand">${_esc(p.brand)}</div></div>
      <div class="search-item__price">${_esc(p.price)}</div>`;
    frag.appendChild(a);
  });

  if (q && filtered.length === 0) {
    const empty = document.createElement('div');
    empty.style.cssText = 'text-align:center;padding:40px 0;color:var(--ink-3);font-style:italic;';
    empty.textContent = 'Nenhum produto encontrado';
    frag.appendChild(empty);
  }

  container.innerHTML = '';
  container.appendChild(frag);
}

// Wire search icon
document.querySelectorAll('.nav__icon[aria-label="Buscar"]').forEach(btn => {
  btn.addEventListener('click', e => { e.preventDefault(); openSearch(); });
});

// Wire input with debounce
const searchInput = document.getElementById('searchInput');
if (searchInput) {
  let debounceTimer;
  searchInput.addEventListener('input', e => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => renderSearch(e.target.value), 150);
  });
}

// Wire search results click
const searchResults = document.getElementById('searchResults');
if (searchResults) {
  searchResults.addEventListener('click', e => {
    const item = e.target.closest('.search-item');
    if (item && item.getAttribute('href').startsWith('#')) {
      e.preventDefault();
      closeSearch();
      const target = document.querySelector(item.getAttribute('href'));
      if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
    } else if (item) {
      closeSearch();
    }
  });
}

// Escape key — only close search if it's the top modal
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && window._modalStack[window._modalStack.length - 1] === 'search') closeSearch();
});
